import React from 'react';
import { useFetchPricePlans } from 'lib/hooks';
import { MORE } from 'constants/shared/routes';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import ManageSubscription from '../presentational/ManageSubscription';
import useTranslate from 'lib/languages/useTranslate';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import { useGetAccountQuery } from 'lib/services';

const ManageSubscriptionContainer = () => {
    const translate = useTranslate('pricePlan');
    const { data: account, isLoading, error } = useGetAccountQuery();
    const {
        pricePlans,
        isFetching: isFetchingPricePlans,
        error: pricePlansError,
    } = useFetchPricePlans();

    return (
        <PageContainer className="more-manage-subscription-container">
            <SectionTitle
                title={translate('breadcrumbText')}
                backRoute={MORE}
            />
            <DataCheck
                data={account || pricePlans}
                isLoading={isLoading || isFetchingPricePlans}
                error={error || pricePlansError}
                noDataMessage={translate('noDataMessage')}
            >
                <ManageSubscription
                    productType={account?.productType}
                    pricePlans={pricePlans}
                />
            </DataCheck>
        </PageContainer>
    );
};

export default ManageSubscriptionContainer;
